'use client';

import { useEffect, useState } from 'react';

/**
 * Whether a competition has opened for entries (its start time has passed),
 * switching to true at the moment it opens, so a page left open on a
 * coming-soon competition starts taking entries without a reload.
 */
export function useOpened(startDate) {
  const opensAt = startDate ? new Date(startDate).getTime() : 0;
  const [opened, setOpened] = useState(() => !opensAt || opensAt <= Date.now());

  useEffect(() => {
    const wait = opensAt - Date.now();
    if (!opensAt || wait <= 0) {
      setOpened(true);
      return undefined;
    }
    setOpened(false);
    // setTimeout can't wait longer than ~24 days; check again then.
    const t = setTimeout(() => setOpened(opensAt <= Date.now()), Math.min(wait + 250, 2_000_000_000));
    return () => clearTimeout(t);
  }, [opensAt]);

  return opened;
}
